export default __webpack_public_path__ + "static/0283-2a393a7958b83208b0c404a06dc595c0.png";